function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "p.0"
}, React.createElement("path", {
  d: "m0 0l100.0 0l0 20.0l-100.0 0l0 -20.0z",
  clipRule: "nonzero"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#p.0)"
}, React.createElement("path", {
  fill: "#333333",
  fillOpacity: 0,
  d: "m0 0l100.0 0l0 20.0l-100.0 0z",
  fillRule: "evenodd"
}), React.createElement("path", {
  fill: "#333333",
  d: "m17.622047 -2.3858268E-4l64.755905 0l0 20.0l-64.755905 0z",
  fillRule: "evenodd"
}), React.createElement("path", {
  fill: "#333333",
  d: "m17.763779 20.236227l-17.763779 -4.4409456l0 -11.590551l17.763779 -4.440945z",
  fillRule: "evenodd"
}), React.createElement("path", {
  fill: "#333333",
  d: "m82.23622 -0.23621443l17.763779 4.440945l0 11.590551l-17.763779 4.4409456z",
  fillRule: "evenodd"
}));

var SvgBar = function SvgBar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 20.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bar.bca9b0ff.svg";
export { ForwardRef as ReactComponent };